export const getToastIndex = (state, toastId) => {
  const toasts = state.getIn(['toasts']);
  const toastIndex = toasts.findIndex((item) => item.get('id') === toastId);

  return toastIndex;
};